__turbopack_context__.v({
  "detail": "dealDetails-module-scss-module__7tLG5W__detail",
  "detailLabel": "dealDetails-module-scss-module__7tLG5W__detailLabel",
  "detailText": "dealDetails-module-scss-module__7tLG5W__detailText",
  "detailsContainer": "dealDetails-module-scss-module__7tLG5W__detailsContainer",
  "detailsContainerBottom": "dealDetails-module-scss-module__7tLG5W__detailsContainerBottom",
  "detailsContainerTop": "dealDetails-module-scss-module__7tLG5W__detailsContainerTop",
  "detailsHolder": "dealDetails-module-scss-module__7tLG5W__detailsHolder",
  "even": "dealDetails-module-scss-module__7tLG5W__even",
  "filingsIcon": "dealDetails-module-scss-module__7tLG5W__filingsIcon",
  "filingsLink": "dealDetails-module-scss-module__7tLG5W__filingsLink",
  "isDisabled": "dealDetails-module-scss-module__7tLG5W__isDisabled",
  "isOpen": "dealDetails-module-scss-module__7tLG5W__isOpen",
  "name": "dealDetails-module-scss-module__7tLG5W__name",
  "nameValueRow": "dealDetails-module-scss-module__7tLG5W__nameValueRow",
  "propertiesContainer": "dealDetails-module-scss-module__7tLG5W__propertiesContainer",
  "property": "dealDetails-module-scss-module__7tLG5W__property",
  "propertyColumn": "dealDetails-module-scss-module__7tLG5W__propertyColumn",
  "propertyLabel": "dealDetails-module-scss-module__7tLG5W__propertyLabel",
  "propertyValue": "dealDetails-module-scss-module__7tLG5W__propertyValue",
  "propertyWrapper": "dealDetails-module-scss-module__7tLG5W__propertyWrapper",
  "showHideBtn": "dealDetails-module-scss-module__7tLG5W__showHideBtn",
  "showHideContainer": "dealDetails-module-scss-module__7tLG5W__showHideContainer",
  "value": "dealDetails-module-scss-module__7tLG5W__value",
});
